export const computePercent = (value: number, denominator: number): number => {
  if (denominator === 0) return 0;
  return Math.round((value / denominator) * 100);
};
